// extracted by mini-css-extract-plugin
export var backgroundImage = "PageSection-module--background-image--7455f";
export var curveBottom = "PageSection-module--curve-bottom--9a35d";
export var curveTop = "PageSection-module--curve-top--cda75";
export var moderate = "PageSection-module--moderate--1b756";
export var noPad = "PageSection-module--no-pad--2628c";
export var pageSection = "PageSection-module--page-section--74457";
export var slim = "PageSection-module--slim--972a6";
export var topSection = "PageSection-module--top-section--a5355 PageSection-module--page-section--74457";
export var width = "PageSection-module--width--80e58";